module.exports = __webpack_public_path__ + "img/girl.2cebe311.png";